import React from 'react';

import { Footer, Header, Skills, Testimonial, Projects} from './container';
import { Navbar } from './components';
import './App.scss';

const App = () => {
  return (
    <div className = "app">
      <Navbar />
      <Header />
      <Skills />
      <Projects />
      <Testimonial />
      <Footer />
    </div>
  );
}

export default App;
